/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { Remediator } from './Base/Remediator';
import { AuthenticatorKey } from '../types';
export class Identify extends Remediator {
    constructor(remediation, values) {
        super(remediation, values);
        this.map = {
            'identifier': ['username'],
            'credentials': []
        };
        // add password authenticator to authenticators list if password is provided
        const { password, authenticators } = this.values;
        if (password && !authenticators.some(authenticator => authenticator.type === 'password')) {
            this.values = Object.assign(Object.assign({}, this.values), { authenticators: [
                    {
                        type: 'password',
                        key: AuthenticatorKey.OKTA_PASSWORD
                    },
                    ...authenticators
                ] });
        }
    }
    canRemediate() {
        const { identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        return { passcode: this.values.password };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), { name: 'password', required: input.required });
    }
    getValuesAfterProceed() {
        var _a;
        // Handle username + password scenario
        // remove "password" from authenticator array when remediation is finished
        if (this.remediation.value.some(({ name }) => name === 'credentials')) {
            const authenticators = (_a = this.values.authenticators) === null || _a === void 0 ? void 0 : _a.filter(authenticator => authenticator.key !== AuthenticatorKey.OKTA_PASSWORD);
            return Object.assign(Object.assign({}, this.values), { authenticators });
        }
        return super.getValuesAfterProceed();
    }
}
Identify.remediationName = 'identify';
